<template>
  <div class="setting_content">
    <div class="setting_content_main">
      <form @change="logChangeData">
        <div class="setting_content_heading">
          <h2 class="setting_content_title">
            {{ labelProperties.HEAD_TITLE }}
          </h2>
        </div>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ labelProperties.NUMBER_JOB_DISPLAY }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ labelProperties.MAX_JOB_DISPLAY }}
            </p>
            <div class="setting_unit_form">
              <div class="setting_unit_form_holder">
                <div class="setting_form_wrapper">
                  <input
                    class="setting_form_text"
                    type="number" min="1" max="50" step="1"
                    v-model="displaySetting.displayRecord"
                    v-on:keypress="(event) => checkInputNumber(event)"
                    @input="checkInputDisplayRecord"
                  />
                </div>
                <span class="setting_unit_form_holder_text">
                  {{labelProperties.CASE }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="setting_unit" @change="updateJobNewWindow()">
          <p class="setting_unit_title">
            {{ labelProperties.VIEW_JOB_NEW_WINDOW }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">{{ labelProperties.JOB_DISPLAY_TYPE }}</p>
            <div class="setting_unit_form">
              <label class="setting_form_radio_label">
                <input
                    type="radio"
                    v-model="displaySetting.jobNewWindow"
                    value="false"
                    id="is_job_new_window_0"
                    checked="checked"
                />
                <label for="is_job_new_window_0" class="setting_form_radio_text">
                  {{ labelProperties.SAME_SCREEN }}
                </label>
              </label>
              <label class="setting_form_radio_label">
                <input
                    type="radio"
                    v-model="displaySetting.jobNewWindow"
                    value="true"
                    id="is_job_new_window_1"
                />
                <label for="is_job_new_window_1" class="setting_form_radio_text">
                  {{ labelProperties.NEW_WINDOW }}
                </label>
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DisplaySettingLabels from "../../../../properties/job_screen/display_setting_tab/display-setting-labels.json";

export default {
  name: "DisplaySettingsTab",
  props: [
    "displaySetting",
  ],
  data() {
    return {
      labelProperties: DisplaySettingLabels
    };
  },
  computed: {
    computedDisplaySetting: {
      get() {
        return this.displaySetting;
      },
      set(val) {
        this.$emit("updatedDisplaySetting", val);
      },
    },
  },
  methods: {
    checkInputNumber(event) {
      event = (event) ? event : window.event;
      let keyCode = (event.which) ? event.which : event.keyCode;
      if ((keyCode > 31 && (keyCode < 48 || keyCode > 57)) && keyCode !== 46) {
        event.preventDefault();
      }
    },

    checkInputDisplayRecord() {
      if (this.computedDisplaySetting.displayRecord > 50) {
        this.computedDisplaySetting.displayRecord = 50;
      }

      if (this.computedDisplaySetting.displayRecord < 1) {
        this.computedDisplaySetting.displayRecord = 1;
      }
    },

    updateJobNewWindow(){
      this.$emit("updatedDisplaySetting", this.computedDisplaySetting);
    },

    logChangeData() {
      this.$eventBus.$emit("unSaved", true);
    },
  },
};
</script>

<style scoped>

</style>
